module.exports = __webpack_public_path__ + "media/hyper/images/small/small-2-ae8239095663eb07be7d246d8524b80f.jpg";